import { render, staticRenderFns } from "./saveEle.vue?vue&type=template&id=f0cade2c&scoped=true&"
import script from "./saveEle.vue?vue&type=script&lang=js&"
export * from "./saveEle.vue?vue&type=script&lang=js&"
import style0 from "./saveEle.vue?vue&type=style&index=0&id=f0cade2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cade2c",
  null
  
)

export default component.exports